import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import instance from "../../api/api.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Dialog } from "primereact/dialog";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
// import { GoPencil } from "react-icons/go";
// import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
// import { Help } from "../../utils";
import { useDispatch } from "react-redux";

import { removeFlagReclamations } from "../../store/slice/ReclamationSlice";
const handleStatut = {
  "en attente": "badge bg-primary",
  refuser: "badge bg-danger",
  accepter: "badge bg-success",
};

function ReclamationsView() {
  //   const navigate = useNavigate();

  const [reclamations, setReclamations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterReclamations, setFilterReclamations] = useState([]);
  const [btnVisible, setBtnVisible] = useState("Toutes");
  const [chooseType, setChooseType] = useState("");
  const VALUE_BTN = [
    {
      value: "en attente",
    },
    {
      value: "accepter",
    },
    {
      value: "refuser",
    },
  ];
  const handleFilterCommande = (value) => {
    console.log("handleFilterCommande", value);
    setReclamations(filterReclamations.filter((item) => item.statut === value));
    setBtnVisible(value);
  };
  const handleAllreclamations = () => {
    setReclamations(filterReclamations);
    setBtnVisible("Toutes");
  };
  const filterBYType = (value) => {
    setChooseType(value);
    setReclamations(filterReclamations.filter((item) => item.type === value));
    console.log("filterBYType", value);
  };
  useEffect(() => {
    const getListReclamations = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("reclamations");
        console.log("reclamations", response.data.data);
        setReclamations(response.data.data.sort((a, b) => b.flag - a.flag));
        setFilterReclamations(
          response.data.data.sort((a, b) => b.flag - a.flag)
        );
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListReclamations();
  }, []);
  return (
    <div className="conteneur-page">
      <h1>Réclamations</h1>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <button
            className="mx-2 bagde p-1 rounded border-1"
            style={{
              background: btnVisible === "Toutes" ? "blue" : null,
              color: btnVisible === "Toutes" ? "white" : null,
            }}
            onClick={() => handleAllreclamations()}
          >
            Tous
          </button>
          {VALUE_BTN.map((item) => (
            <button
              className="mx-2 bagde p-1 rounded border-1"
              style={{
                background:
                  btnVisible === "en attente" && item.value === "en attente"
                    ? "gray"
                    : btnVisible === "accepter" && item.value === "accepter"
                    ? "green"
                    : btnVisible === "refuser" && item.value === "refuser"
                    ? "red"
                    : btnVisible === "annulée" && item.value === "annulée"
                    ? "red"
                    : btnVisible === "Confirmer" && item.value === "Confirmer"
                    ? "green"
                    : "transparent",
                color:
                  btnVisible === "en attente" && item.value === "en attente"
                    ? "white"
                    : btnVisible === "accepter" && item.value === "accepter"
                    ? "white"
                    : btnVisible === "refuser" && item.value === "refuser"
                    ? "white"
                    : btnVisible === "annulée" && item.value === "annulée"
                    ? "white"
                    : btnVisible === "Confirmer" && item.value === "Confirmer"
                    ? "white"
                    : "black",
              }}
              key={item.value}
              value={item.value}
              onClick={(e) => handleFilterCommande(e.target.value)}
            >
              {item.value}
            </button>
          ))}
        </div>
        <select
          name=""
          id=""
          className="p-2"
          onChange={(e) => filterBYType(e.target.value)}
        >
          <option value="" selected disabled>
            Choisir le type
          </option>
          <option value="remboursement">remboursement</option>
          <option value="retour">retour</option>
        </select>
      </div>

      {isLoading ? (
        <h1 className="text-center">Chargement...</h1>
      ) : (
        <ReclamationDatatable items={reclamations} />
      )}
    </div>
  );
}
function ReclamationDatatable({ items }) {
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const dt = useRef(null);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [idProduit, setIdProduit] = useState("");
  const [valueOfCategorie, setValueOfCategorie] = useState("");
  const [visibleModifier, setVisibleModifier] = useState(false);
  const [isLoadingChange, setIsLoadingChange] = useState(false);
  const [dataModif, setDataModif] = useState({
    libelle: "",
  });

  // const handleCatgeorie = (id) => {
  //   console.log("idProduit", id);
  //   setIdProduit(id);
  //   setVisible(true);
  // };
  const seeDetailCommande = (id, type) => {
    console.log("idProduit", id);
    dispatch(removeFlagReclamations(id));
    navigate(`/reclamations/commandes/${id}/detail/${type}`);
  };
  const handleModification = async () => {
    setIsLoadingChange(true);
    try {
      const response = await instance.put(
        "reclamations/" + idProduit,
        dataModif
      );
      console.log("CATEGORIE_MODIFIER", response);
      const element = items.find((item) => item.id === idProduit);
      element.libelle = dataModif.libelle;
      setIsLoadingChange(false);
    } catch (error) {
      console.log(error);
      setIsLoadingChange(false);
    }
  };
  const handleDeleteCategorie = async () => {
    setIsLoadingChange(true);
    try {
      const response = await instance.delete("reclamations/" + idProduit);
      console.log("CATEGORIE_DELETE", response);
      if (response.data.status === true) {
        const element = items.findIndex((item) => item.id === idProduit);
        items.splice(element, 1);
        setIsLoadingChange(false);
        setVisible(false);
        MySwal.fire({
          title: `Le produit a été supprimé avec succès `,
          icon: "success",
          showConfirmButton: true,
        });
      }
      if (response.data.status === false) {
        MySwal.fire({
          title: response.data.message.libelle[0],
          icon: "info",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoadingChange(false);
    }
  };
  // const detailsPrice = (rowData) => {
  //   return <p>{Help.convertInMoney(rowData.total)}</p>;
  // };
  const detailsCommande = (rowData) => {
    return rowData.commande.reference;
  };
  // const detailsQuantite = (rowData) => {
  //   return rowData.produits.map((item) => (
  //     <p key={item.id} className="d-block text-center">
  //       {item.quantite}
  //     </p>
  //   ));
  // };
  const detailsStatut = (rowData) => {
    return (
      <span className={handleStatut[rowData.statut]}>{rowData.statut}</span>
      //   <div>
      //     rowData.statut === "en attente" ??

      //     {/* {rowData.statut === "en cours" ?? (
      //       <span
      //         className="badge bg-primary
      //         "
      //       >
      //         {rowData.statut}
      //       </span>
      //     )}
      //     {rowData.statut === "livrée" ?? (
      //       <span
      //         className="badge bg-success
      //         "
      //       >
      //         {rowData.statut}
      //       </span>
      //     )}
      //     {rowData.statut === "annulée" ?? (
      //       <span
      //         className="badge bg-danger
      //         "
      //       >
      //         {rowData.statut}
      //       </span>
      //     )} */}
      //   </div>
    );
  };
  const detailsDate = (rowData) => {
    return (
      <p>
        {rowData.flag > 0 && (
          <span
            className="badge bg-danger position-absolute animated-box"
            style={{
              top: "0",
              left: "1em",
            }}
          >
            Nouvelle
          </span>
        )}
        {new Date(rowData.created_at).toLocaleDateString("fr")}
      </p>
    );
  };
  const detailsName = (rowData) => {
    return (
      <p>
        {rowData.user.nom} {rowData.user.prenom}
      </p>
    );
  };
  const detailsPhone = (rowData) => {
    return <p>{rowData.user.phone}</p>;
  };
  const detailsInfo = (rowData) => {
    return (
      <div className="d-flex align-items-center gap-1 justify-content-center flex-wrap">
        <button
          className="btn-lg bg-primary border-0 rounded-1 p-2  text-light fw-bold"
          onClick={() => seeDetailCommande(rowData.id, rowData.type)}
        >
          <IoEyeOutline fontSize="1em" />
          Voir plus
        </button>
        {/* <button
          className="btn-lg bg-danger border-0 rounded-3 p-2 text-light fw-bold"
          onClick={() => handleCatgeorie(rowData.id)}
        >
          <MdDeleteOutline fontSize="1.5em" />
          
        </button> */}
      </div>
    );
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    commande: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    const conteneurSearch = {
      padding: "1.3em",
    };
    // console.log(
    //   "items",
    //   items.map((obj) => {
    //     const {
    //       id,
    //       user_id,
    //       commentaire,
    //       created_at,
    //       produits,
    //       user,
    //       updated_at,
    //       deleted_at,
    //       ...rest
    //     } = obj;

    //     rest.client = obj.user.nom + " " + obj.user.prenom;
    //     rest.contact = obj.user.phone;
    //     rest.email = obj.user.email;
    //     rest.date_commande = obj.date_commande.split(" ")[0];
    //     let produit = [];
    //     obj.produits.forEach((element) => {
    //       produit.push(
    //         element.produit.nom + " " + "(" + element.quantite + ")"
    //       );
    //     });
    //     rest.produit = produit.join(", ");
    //     rest.total_produit = obj.produits.length;
    //     return rest;
    //   })
    // );
    // const itemsAtExportInExcel = items.map((obj) => {
    //   const {
    //     id,
    //     user_id,
    //     commentaire,
    //     created_at,
    //     produits,
    //     updated_at,
    //     deleted_at,
    //     user,
    //     ...rest
    //   } = obj;
    //   rest.totalProduit = obj.produits.length;
    //   rest.client = obj.user.nom + " " + obj.user.prenom;
    //   rest.contact = obj.user.phone;
    //   rest.email = obj.user.email;
    //   rest.date_commande = obj.date_commande.split(" ")[0];
    //   let produit = [];
    //   obj.produits.forEach((element) => {
    //     produit.push(element.produit.nom + " " + "(" + element.quantite + ")");
    //   });
    //   rest.produit = produit.join(", ");
    //   rest.total_produit = obj.produits.length;
    //   return rest;
    // });
    // const exportExcel = () => {
    //   import("xlsx").then((xlsx) => {
    //     const worksheet = xlsx.utils.json_to_sheet(itemsAtExportInExcel);
    //     const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    //     const excelBuffer = xlsx.write(workbook, {
    //       bookType: "xlsx",
    //       type: "array",
    //     });

    //     saveAsExcelFile(excelBuffer, "files");
    //   });
    // };

    // const saveAsExcelFile = (buffer, fileName) => {
    //   import("file-saver").then((module) => {
    //     let EXCEL_TYPE =
    //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    //     let EXCEL_EXTENSION = ".xlsx";
    //     const data = new Blob([buffer], {
    //       type: EXCEL_TYPE,
    //     });

    //     module.default.saveAs(
    //       data,
    //       fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    //     );
    //   });
    // };
    return (
      <div className="conteneur-search">
        <Dialog
          header="Voulez-vous vraiment supprimer ce produit."
          visible={visible}
          style={{ width: "50vw" }}
          onHide={() => {
            if (!visible) return;
            setVisible(false);
          }}
        >
          <button
            onClick={() => handleDeleteCategorie()}
            className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold"
          >
            {isLoadingChange ? "Chargement..." : "Confirmer"}
          </button>
          <button
            onClick={() => setVisible(false)}
            className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
          >
            Annuler
          </button>
        </Dialog>
        <Dialog
          header="Modification de la catégorie"
          visible={visibleModifier}
          style={{ width: "50vw" }}
          onHide={() => {
            if (!visibleModifier) return;
            setVisibleModifier(false);
          }}
        >
          <input
            type="text"
            defaultValue={valueOfCategorie}
            onChange={(e) =>
              setDataModif({ ...dataModif, libelle: e.target.value })
            }
          />
          <button
            onClick={() => handleModification()}
            className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold"
          >
            {isLoadingChange ? "Chargement..." : "Confirmer"}
          </button>
          <button
            onClick={() => setVisibleModifier(false)}
            className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
          >
            Annuler
          </button>
        </Dialog>
        {/* <div className="btn-upload-file">
          <Button
            type="button"
            label="Excel format"
            icon="pi pi-file-excel"
            style={{
              border: "none",
              color: "white",
              margin: "1em 0",
            }}
            onClick={exportExcel}
            data-pr-tooltip="XLS"
          />
        </div> */}

        <InputText
          value={globalFilterValue}
          onChange={onGlobalFilterChange}
          placeholder="Keyword Search"
          style={conteneurSearch}
        />
      </div>
    );
  };
  const header = renderHeader();

  return (
    <div>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={[
              "created_at",
              "user.nom",
              "user.phone",
              "total",
              "reference",
              "commande.reference"
            ]}
            header={header}
          >
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Date d'enregistrement"
              body={detailsDate}
            ></Column>
            <Column
              field="type"
              style={{ textAlign: "center" }}
              header="Type"
            ></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Client"
              body={detailsName}
            ></Column>
            <Column
              field="phone"
              style={{ textAlign: "center" }}
              header="Contact"
              body={detailsPhone}
            ></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              body={detailsCommande}
              header="Référence commande"
            ></Column>

            {/* <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Prix Total (Fcfa)"
              body={detailsPrice}
            ></Column> */}
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Statut"
              body={detailsStatut}
            ></Column>

            {/* 
            
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Catégorie"
              body={detailsCategorie}
            ></Column> */}
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}
            ></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ReclamationsView;
